/* File generated automatically, do not edit */
export enum SchemaNames {
  APIKEY = 'ApiKey',
  AUDIT = 'Audit',
  CARD = 'Card',
  CARDBARCODE = 'CardBarcode',
  CARDPLACEHOLDER = 'CardPlaceholder',
  CARDSEASONAL = 'CardSeasonal',
  CAROUSEL = 'Carousel',
  CART = 'Cart',
  CART_CARTHISTORYITEM = 'Cart.CartHistoryItem',
  CART_CARTITEM = 'Cart.CartItem',
  CATEGORY = 'Category',
  CATEGORY_SUBCATEGORY = 'Category.SubCategory',
  CHALLENGE = 'Challenge',
  CHALLENGE_CHALLENGEPARTICIPANT = 'Challenge.ChallengeParticipant',
  CHECKOUTCODE = 'CheckoutCode',
  CHECKOUTCODE_CHECKOUTCODEREDEMPTION = 'CheckoutCode.CheckoutCodeRedemption',
  CLOUDTASKERROR = 'CloudTaskError',
  COUPON = 'Coupon',
  DEALERORDER = 'DealerOrder',
  DEPARTURE = 'Departure',
  DISCOUNT = 'Discount',
  DISCOUNT_DISCOUNTUSAGE = 'Discount.DiscountUsage',
  DISTRICT = 'District',
  EXPORTPRESET = 'ExportPreset',
  EXPORTREQUEST = 'ExportRequest',
  EXTERNALCODE = 'ExternalCode',
  FAILEDHOOK = 'FailedHook',
  FAILEDTRANSIT = 'FailedTransit',
  FORM = 'Form',
  GALLERY = 'Gallery',
  GALLERY_GALLERYITEM = 'Gallery.GalleryItem',
  GUESTCARD = 'Guestcard',
  GUESTCARD_CONSUMPTION = 'Guestcard.Consumption',
  GURU = 'Guru',
  HOTELPRICE = 'HotelPrice',
  MEMBERSHIP = 'Membership',
  MEMBERSHIPTRANSIT = 'MembershipTransit',
  MEMBERSHIPTURNSTILEEVENT = 'MembershipTurnstileEvent',
  NOTE = 'Note',
  NOTIFICATION = 'Notification',
  ORDER = 'Order',
  ORDER_DELETEDORDERITEM = 'Order.DeletedOrderItem',
  ORDER_ORDERITEM = 'Order.OrderItem',
  ORDER_ORDERPAYMENTERROR = 'Order.OrderPaymentError',
  ORDERTMP = 'OrderTmp',
  ORDERTMP_ORDERITEMCHANGE = 'OrderTmp.OrderItemChange',
  ORDERTRANSACTION = 'OrderTransaction',
  ORDERTRANSACTION_GATEWAYCHARGE = 'OrderTransaction.GatewayCharge',
  ORDERTRANSACTION_GATEWAYLOG = 'OrderTransaction.GatewayLog',
  ORDERTRANSACTION_GATEWAYREFUND = 'OrderTransaction.GatewayRefund',
  ORDERTRANSACTION_GATEWAYREVERSAL = 'OrderTransaction.GatewayReversal',
  ORDERTRANSACTION_GATEWAYTRANSFER = 'OrderTransaction.GatewayTransfer',
  ORDERTRANSACTION_ITEMTRANSFER = 'OrderTransaction.ItemTransfer',
  ORDERTRANSACTION_PAYMENTINTENT = 'OrderTransaction.PaymentIntent',
  PPUPRICERATE = 'PPUPriceRate',
  PARTNER = 'Partner',
  PARTNERSTRIPE = 'PartnerStripe',
  PASSAGE = 'Passage',
  PAYMENT = 'Payment',
  PERFORMANCE = 'Performance',
  PERFORMANCE_PERFORMANCEDAY = 'Performance.PerformanceDay',
  POLICY = 'Policy',
  PRICE = 'Price',
  PRICECLUSTER = 'PriceCluster',
  PRODUCT = 'Product',
  PRODUCT_DETAIL = 'Product.Detail',
  PRODUCT_DETAILBUNDLETRAVEL = 'Product.DetailBundleTravel',
  PRODUCT_DETAILCONDITION = 'Product.DetailCondition',
  PRODUCT_DETAILCONTENTBLOCK = 'Product.DetailContentBlock',
  PRODUCT_DETAILFULLDESCRIPTION = 'Product.DetailFullDescription',
  PRODUCT_DETAILITINERARY = 'Product.DetailItinerary',
  PRODUCT_DETAILMETATAG = 'Product.DetailMetaTag',
  PRODUCT_DETAILPRODUCTDESCRIPTION = 'Product.DetailProductDescription',
  PRODUCT_DETAILTEXT = 'Product.DetailText',
  PRODUCT_EXTERNALPROVIDERPARAM = 'Product.ExternalProviderParam',
  PRODUCT_MEMBERSHIPSEASON = 'Product.MembershipSeason',
  PRODUCT_PERIODPRICE = 'Product.PeriodPrice',
  PRODUCT_SLOT = 'Product.Slot',
  PRODUCT_STAGEDETAIL = 'Product.StageDetail',
  PRODUCT_VARIANT = 'Product.Variant',
  PRODUCTBOOKING = 'ProductBooking',
  PRODUCTHOST = 'ProductHost',
  PRODUCTOPTION = 'ProductOption',
  PRODUCTSTOCK = 'ProductStock',
  PRODUCTSTOCK_AGGREGATEDBOOKING = 'ProductStock.AggregatedBooking',
  PROVIDERORDER = 'ProviderOrder',
  PROVIDERORDER_MIDDLEWARERESPONSE = 'ProviderOrder.MiddlewareResponse',
  PROVIDERORDER_PROVIDERORDERLOG = 'ProviderOrder.ProviderOrderLog',
  PROVIDERSUPPORT = 'ProviderSupport',
  REVIEW = 'Review',
  ROLE = 'Role',
  ROUTE = 'Route',
  SEASON = 'Season',
  SETTING = 'Setting',
  SETTING_SETTINGESSELUNGADISCOUNT = 'Setting.SettingEsselungaDiscount',
  SETTING_SETTINGQUICKBOOKS = 'Setting.SettingQuickBooks',
  SHARE = 'Share',
  SHIPPINGMETHOD = 'ShippingMethod',
  STAGE = 'Stage',
  STRIPECUSTOMER = 'StripeCustomer',
  STRIPECUSTOMER_PAYMENTSOURCE = 'StripeCustomer.PaymentSource',
  TAG = 'Tag',
  TASK = 'Task',
  TASK_TASKERROR = 'Task.TaskError',
  TENANT = 'Tenant',
  TENANT_CONFIG = 'Tenant.Config',
  TENANT_CONFIGAPP = 'Tenant.ConfigApp',
  TENANT_CONFIGHOTEL = 'Tenant.ConfigHotel',
  TENANT_CONFIGIFS = 'Tenant.ConfigIfs',
  TENANT_CONFIGITINERARY = 'Tenant.ConfigItinerary',
  TENANT_CONFIGLAYOUTS = 'Tenant.ConfigLayouts',
  TENANT_CONFIGMAIN = 'Tenant.ConfigMain',
  TENANT_CONFIGMARKETING = 'Tenant.ConfigMarketing',
  TENANT_CONFIGPRODUCTS = 'Tenant.ConfigProducts',
  TENANT_CONFIGREFERRALS = 'Tenant.ConfigReferrals',
  TENANT_CONFIGSATISPAY = 'Tenant.ConfigSatispay',
  TENANT_CONFIGSNOWITCARDS = 'Tenant.ConfigSnowitcards',
  TENANT_CONFIGTHEME = 'Tenant.ConfigTheme',
  TENANT_CONFIGUPSELLS = 'Tenant.ConfigUpsells',
  TENANT_CONFIGWALLET = 'Tenant.ConfigWallet',
  TENANT_CONFIGWIDGET = 'Tenant.ConfigWidget',
  TENANT_TENANTEMAIL = 'Tenant.TenantEmail',
  TENANT_TENANTMESSAGE = 'Tenant.TenantMessage',
  TESTMODEL = 'TestModel',
  TURNSTILE = 'Turnstile',
  USER = 'User',
  USER_USERFOLLOWER = 'User.UserFollower',
  USER_USERFOLLOWERSRELATION = 'User.UserFollowersRelation',
  USER_USERFRIEND = 'User.UserFriend',
  USER_USERPRIVACY = 'User.UserPrivacy',
  USER_USERPROFILE = 'User.UserProfile',
  USER_USERPROVIDER = 'User.UserProvider',
  USER_USERPROVIDERQUICKBOOKS = 'User.UserProviderQuickBooks',
  USER_USERREFERRAL = 'User.UserReferral',
  USER_USERTOKEN = 'User.UserToken',
  USER_USERWALLETTRANSACTION = 'User.UserWalletTransaction',
  USER_USERWALLETTRANSACTIONARCHIVE = 'User.UserWalletTransactionArchive',
  VENUE = 'Venue',
  VENUE_STOCK = 'Venue.Stock',
  ZONE = 'Zone',
  ZONE_DETAIL = 'Zone.Detail',
  ZONE_DETAILTRANSLATION = 'Zone.DetailTranslation',
  ZONE_HOTELPRICE = 'Zone.HotelPrice',
}
